<template>
  <div class="action-button">
    <vs-tooltip text="編集" position="bottom">
      <div class="action-button-icon" @click.stop="onClickEdit(null)">
        <vs-icon icon="edit" size="22px" class="material-icons-outlined" />
      </div>
    </vs-tooltip>
  </div>
</template>

<script>
export default {
  name: "CellRendererRowActionButtons",
  methods: {
    onClickEdit() {
      this.params.edit(this.params.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.action-button {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .action-button-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      background: rgb(199, 199, 199);
    }
  }
}
</style>
